import React, { useEffect, useRef, useState } from 'react';

import { IInput } from '../../types/global';
import { ErrorIcon, Tooltip } from '../Input/InputElements';

import { IDropdown } from './Dropdown';
import {
  ButtonDrop,
  ChevronIconAnimate,
  CloseButton,
  Container,
  Content,
  DropMenu,
  Header,
  Item,
  Label,
  Placeholder,
  TickIcon,
  Title,
  Wrapper,
} from './DropdownElements';

const Dropdown = (props: IDropdown.IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [valueState, setValueState] = useState<IInput.TValue>(props.value);
  const toggling = () => setIsOpen(!isOpen);
  const onChooseItem = (event: IDropdown.ItemType) => {
    const value = event.id || event.value;
    setValueState(value);
    props.onChange({
      target: { name: props.name, value },
    });
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setValueState(props.value);
  }, [props.value]);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) => {
      // Check if the clicked element is outside the dropdown
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        // Close the dropdown (you can add your logic here)
        setIsOpen(false);
      }
    };

    // Attach the event listener
    document.addEventListener('click', handleDocumentClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  const title = props.options?.find(
    (item) => item.id === valueState || item.value === valueState,
  )?.title;

  return (
    <Wrapper marginWrapper={props.marginWrapper} ref={dropdownRef}>
      <ButtonDrop onClick={toggling} className={`${props.hasError ? '!tw-border-red500' : ''}`}>
        {props.name.includes('color') && (
          <span
            className={'tw-min-w-[20px] tw-h-[20px] tw-rounded-[10px] tw-border-[1px]'}
            style={{
              backgroundColor: title,
            }}
          />
        )}
        {title || (!props.label && 'Select ...')}
        {props.isVerified && <TickIcon className={'icon-Check'} />}
        <ChevronIconAnimate isOpen={isOpen} className={'icon-Big-Arrows'} />
      </ButtonDrop>
      <Label
        isOpen={isOpen}
        hasValue={!!valueState}
        className={`${props.hasError ? '!tw-text-red500' : ''}`}
      >
        {props.label}
      </Label>
      {props.hasError && <ErrorIcon className={'icon-alert-circle'} />}
      {props.hasError && <Tooltip>{props.errorMessage}</Tooltip>}
      {props.options && props.options.length > 0 && (
        <Container isShow={isOpen} onClick={toggling}>
          <Content isShow={isOpen} onClick={(e) => e.stopPropagation()}>
            <Header>
              <Title>{props.name.replace(/_/g, ' ')}</Title>
              <CloseButton className={'icon-Close-Outline'} onClick={toggling} />
            </Header>
            <DropMenu>
              {props.options?.map((item, index) => (
                <Item
                  key={item.id || item.value}
                  onClick={() => {
                    onChooseItem(item);
                    setIsOpen(false);
                  }}
                >
                  {props.name.includes('color') && (
                    <span
                      className={'tw-min-w-[20px] tw-h-[20px] tw-rounded-[10px] tw-border-[1px]'}
                      style={{
                        backgroundColor: item.title,
                      }}
                    />
                  )}
                  {item.title}
                </Item>
              ))}
            </DropMenu>
          </Content>
        </Container>
      )}
    </Wrapper>
  );
};

Dropdown.defaultProps = {
  list: [],
  title: '',
  value: '',
  placeholder: '',
  isVerified: false,
  marginWrapper: '',
  onChange: () => null,
};

export { Dropdown };
